export default {
  validate: {
    method: 'post',
    url: '/client/order/allotment/validate/ORDER_ID'
  },
  add: {
    method: 'post',
    url: '/client/order/allotment/ORDER_ID'
  },
  addVendor: {
    method: 'post',
    url: '/client/order/allotment/ORDER_ID/add-vendor'
  }
}
